import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function NoInvite() {
  const navigate = useNavigate();

  useEffect(() => {
    // Sign the user out so they don't sit in a half-state
    supabase.auth.signOut();
  }, []);

  return (
    <main className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle className="text-xl font-heading">No invitation found</CardTitle>
          <CardDescription>
            This email isn\u2019t on the invite list yet. Ask your admin to invite this address,
            then sign in again.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button className="w-full" onClick={() => navigate('/auth/signin')}>
            Try a different email
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
